// "Rows per page" on the alerts table is local state in AlertsTable, and the
// parent unmounts the table for every list refresh (`!refreshingData &&`), so
// a plain useState(25) snapped back to 25 the moment the background sync
// found a new alert (SUP-510). Persist it like the column width offset so it
// survives remounts (and, as a bonus, reloads).
export const ALERTS_ROWS_PER_PAGE_STORAGE_KEY = "alertsTableRowsPerPage";
export const ALERTS_ROWS_PER_PAGE_OPTIONS = [25, 50, 100];
export const DEFAULT_ALERTS_ROWS_PER_PAGE = ALERTS_ROWS_PER_PAGE_OPTIONS[0];

export const readStoredAlertsRowsPerPage = () => {
  try {
    const raw = window.localStorage.getItem(ALERTS_ROWS_PER_PAGE_STORAGE_KEY);
    const parsed = raw === null ? NaN : Number(raw);
    return ALERTS_ROWS_PER_PAGE_OPTIONS.includes(parsed)
      ? parsed
      : DEFAULT_ALERTS_ROWS_PER_PAGE;
  } catch {
    return DEFAULT_ALERTS_ROWS_PER_PAGE;
  }
};

export const storeAlertsRowsPerPage = (rowsPerPage: number) => {
  try {
    window.localStorage.setItem(
      ALERTS_ROWS_PER_PAGE_STORAGE_KEY,
      String(rowsPerPage)
    );
  } catch {
    // localStorage unavailable (private mode) — the choice just won't persist
  }
};
